import { render, staticRenderFns } from "./OptaSetup.vue?vue&type=template&id=fab83bfa&"
import script from "./OptaSetup.vue?vue&type=script&lang=js&"
export * from "./OptaSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports